import { gql } from '__generated__'

export const GetRostersByName = gql(/* GraphQL */ `
    query GetRostersByName(
        $name: String!
        $limit: Int
        $page: Int
        $onlyMyRosters: Boolean
        $includeAllMyRosters: Boolean
        $includeDrafts: Boolean
        $includeClosedRosters: Boolean
        $currentRosterId: ID
    ) {
        rostersByName(
            name: $name
            limit: $limit
            page: $page
            includeDrafts: $includeDrafts
            onlyMyRosters: $onlyMyRosters
            includeAllMyRosters: $includeAllMyRosters
            includeClosedRosters: $includeClosedRosters
            currentRosterId: $currentRosterId
        ) {
            data {
                id
                rosterName
                rosterType
                status
            }
            pageInfo {
                itemTotal
                pageNumber
                pageTotal
            }
        }
    }
`)

export const GetRostersByIds = gql(/* GraphQL */ `
    query GetRostersByIds($ids: [ID!]!) {
        rostersByIds(ids: $ids) {
            id
            rosterName
            rosterType
            status
        }
    }
`)
